<template>
  <div class="cell-wrapper">
    <div class="msg-title">
      <span class="user-name">{{
        comment.userInfoExtend || comment.commentPraiseUserInfo.name
      }}</span>
      <span class="msg-tip">{{ commentTip }}</span>
      <p class="work-title">
        <a
          class="link-tag"
          href="javascript:void(0)"
          @click="initProductLink"
          >{{ comment.title }}</a
        >
      </p>
    </div>
    <div class="msg-content flex relative">
      <a href="javascript:void(0)" @click="initUserLink"
        ><UserAvatar :src="comment.commentPraiseUserInfo.headImgUrl"
      /></a>
      <div class="comment-body">
        <p class="name text-ellipsis">
          <a href="javascript:void(0)" @click="initUserLink">{{
            comment.userInfoExtend || comment.commentPraiseUserInfo.name
          }}</a>
          <span>：{{ comment.commentPraiseContent }}</span>
        </p>
        <span class="time">{{ date }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getFullDate } from "../utils/date";
import UserAvatar from "./UserAvatar";
export default {
  name: "comment-notice",
  props: {
    comment: Object,
  },
  //[0].commentPraiseUserInfo.headImgUrl
  components: {
    UserAvatar,
  },
  computed: {
    date() {
      return getFullDate(new Date(this.comment.commentPraiseDate * 1000));
    },
    commentTip() {
      switch (this.comment.modelType) {
        case 1:
          return "评论了你的文章";
        case 2:
          return "评论了你的相册";
        case 3:
          return "评论了你的音频";
        case 4:
          return "评论了你的视频";
      }
    },
  },
  methods: {
    initProductLink() {
      // console.log(this.comment)
      if (this.comment.hasOwnProperty("modelId")) {
        // this.$router.push({
        //   path: "detail",
        //   query: {
        //     feedID: this.comment.modelId,
        //     feedType: this.comment.modelType,
        //   },
        // });
        let routerClanCard = this.$router.resolve({
          path: "detail",
          query: {
            feedID: this.comment.modelId,
            feedType: this.comment.modelType,
          },
        });
        window.open(routerClanCard.href, "_blank");
      }
    },
    initUserLink() {
      if (this.comment.hasOwnProperty("commentPraiseUserId")) {
        this.$router.push({
          path: "/feed",
          query: {
            id: this.comment.commentPraiseUserId,
          },
        });
      }
    },
  },
};
</script>
<style scoped>
.flex {
  display: flex;
}

.cell-wrapper {
  margin-bottom: 2px;
  padding: 10px 15px;
  box-sizing: border-box;
  background-color: #fff;
  border-bottom: 1px solid #f6f7f8;
}

.msg-title .work-title {
  height: 30px;
  margin: 5px 0;
  padding-left: 8px;
  line-height: 30px;
  font-size: 14px;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: #f2f2f2;
  border-radius: 5px;
}

.link-tag {
  color: #333333;
}

.msg-title .msg-tip {
  margin-left: 5px;
  color: #808080;
}

.msg-content .comment-body {
  margin-left: 10px;
  line-height: 25px;
}

.comment-body .time {
  color: #ccc;
}

.comment-body .name {
  width: 560px;
}

.name a {
  color: #1a70db;
}
</style>
